import { configureStore } from '@reduxjs/toolkit';
import { categoriesSlice } from './states/categories';
import customizationReducer from './states/customizationReducer';
import { userSlice } from './states/user';
import { UtilityApiSlice } from './states/utility_api';
import { retailersSlice } from './states/retailers';
import { sourcesSlice } from './states/sources';
import { modelNumberSlice } from './states/modelNumber';
import { masterCategoriesSlice } from './states/masterCategories';
import { usersSlice } from './states/users';
import rootReducer from '../app/components/customdashboard/reducers';
import { clientsSlice } from './states/clients';
import { fileTypesSlice } from './states/fileTypes';
import { delimetersSlice } from './states/delimeters';
import { skipOptionsSlice } from './states/skipOptions';
import { schemasSlice } from './states/schemas';
import { productsSlice } from './states/products';
import { subproductsSlice } from './states/subproducts';
import { locationsSlice } from './states/locations';
import { genericsSlice } from './states/generics';
import { domainSlice } from './states/domain';
import { versionsSlice } from './states/versions';

export const DataBuddiesStore = configureStore({
  reducer: {
    // add your slices to the store
    // remeber add to the store when you need use the state in all pages or components its a best practices

    //FileHub
    clients: clientsSlice.reducer,
    fileTypes: fileTypesSlice.reducer,
    delimeters: delimetersSlice.reducer,
    locations: locationsSlice.reducer,
    products: productsSlice.reducer,
    schemas: schemasSlice.reducer,
    subproducts: subproductsSlice.reducer,
    skipOptions: skipOptionsSlice.reducer,
    versions: versionsSlice.reducer,

    generics: genericsSlice.reducer,

    categories: categoriesSlice.reducer,
    domain: domainSlice.reducer,
    customization: customizationReducer,
    masterCategories: masterCategoriesSlice.reducer,
    modelNumber: modelNumberSlice.reducer,
    retailers: retailersSlice.reducer,
    sources: sourcesSlice.reducer,
    users: usersSlice.reducer,
    user: userSlice.reducer,
    utility_api: UtilityApiSlice.reducer,
    root: rootReducer,
  },
});

export default DataBuddiesStore;
